module.exports = __webpack_public_path__ + "ring-twilight-red.2b92ff7ac60137aef6ea.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/ring-twilight-red.svg
// module id = ../../../../../src/assets/img/ring-twilight-red.svg
// module chunks = main